<div class="wrapper">
  <img [src]="imgSrc" alt="table image" />
</div>
